import { v4 as uuidv4 } from 'uuid';
import thumb1 from '../../assets/img/home3/services1.webp';
import thumb2 from '../../assets/img/home3/services2.webp';
import thumb3 from '../../assets/img/home3/services3.webp';
import thumb4 from '../../assets/img/home3/services4.webp';

const servicesThreeData = [
    {
        id: uuidv4(),
        thumbnail: thumb1,
        index: '01',
        heading: 'Engine Parts',
        text: 'We supply a comprehensive range of engine components for heavy machinery, sourced from globally recognized OEM and aftermarket manufacturers.',
    },

    {
        id: uuidv4(),
        thumbnail: thumb2,
        index: '02',
        heading: 'Undercarriage Systems',
        text: 'Track chains, rollers, sprockets, and full undercarriage assemblies for Komatsu, CAT, Hitachi, Kobelco, and more.',
    },
    {
        id: uuidv4(),
        thumbnail: thumb3,
        index: '03',
        heading: 'Turbochargers',
        text: 'As an Authorised Dealer of Garrett Turbochargers, we also carry Holset, IHI, BorgWarner, Schwitzer, and Mitsubishi turbocharger brands.',
    },

    {
        id: uuidv4(),
        thumbnail: thumb4,
        index: '04',
        heading: 'Filtration & Seals',
        text: 'Complete filtration solutions from Fleetguard, Racor (Parker), and Donaldson, as well as NOK and HST seals and hydraulic hose couplings.',
    },
];

export default servicesThreeData;
